export default __webpack_public_path__ + "static/media/sold_ru.da9638b3.png";